import { render, staticRenderFns } from "./patientList.vue?vue&type=template&id=3c4171c0&scoped=true"
import script from "./patientList.vue?vue&type=script&lang=js"
export * from "./patientList.vue?vue&type=script&lang=js"
import style0 from "./patientList.vue?vue&type=style&index=0&id=3c4171c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4171c0",
  null
  
)

export default component.exports